import Cookies from 'js-cookie';
import { useEffect } from 'react';

export const REMEMBERED_PAGE_COOKIE = 'remembered_page';

export enum RememberedPages {
    Main = 'main',
    Crunchyroll = 'crynchyroll',
    LiveTV = 'liveTV',
}

export const useRemeberPage = (page: RememberedPages) => {
    useEffect(() => {
        Cookies.set(REMEMBERED_PAGE_COOKIE, page, { sameSite: 'lax', secure: true });
    }, [page]);
};
